export interface IContentTypeButtonsProps {
  value: GlobalPartnerContentTypes
  translationKeyPrefix: string
  onContentTypeChange: (newValue: GlobalPartnerContentTypes) => void
  isNewGlobalPartner: boolean
}

export enum GlobalPartnerContentTypes {
  BasicInfo = 'basic-info',
  List = 'list',
  Map = 'map',
  EntityManagement = 'entity-management',
  Diagram = 'diagram',
}
